import axios from 'axios'
import { API } from '../../utils/index'
const instance = axios.create()


export const getMediaAperances = async () => {
	const _endpoint = 'mediaaperance'
	const URL = `${API}/${_endpoint}`
	return instance.get(URL)
}